import { ConfigOrderDetails } from '../types';
import formatConfigToMap from './formatConfigToMap';

function formatFieldValue(s: string): string {
  if (s === '') {
    return '-';
  }
  return s;
}

function formatConfigToText(configOrderDetails: ConfigOrderDetails): string {
  let formatedText = '';
  const listMapOrderDetails = formatConfigToMap(configOrderDetails);
  listMapOrderDetails.forEach((mapOrderDetails) => {
    formatedText += `${mapOrderDetails.label}: ${formatFieldValue(mapOrderDetails.value)}\n`;
  });
  return formatedText;
}

export default formatConfigToText;
